export const onboardingModes = ['express', 'guided', 'strategy'] as const

export type OnboardingMode = (typeof onboardingModes)[number]

let inMemoryOnboardingMode: OnboardingMode | null = null

const modeLabels: Record<OnboardingMode, string> = {
  express: 'Express-Onboarding',
  guided: 'Gefuehrtes Onboarding',
  strategy: 'Strategie-Onboarding',
}

export function readOnboardingMode(): OnboardingMode | null {
  return inMemoryOnboardingMode
}

export function saveOnboardingMode(mode: OnboardingMode) {
  inMemoryOnboardingMode = mode
}

export function clearOnboardingMode() {
  inMemoryOnboardingMode = null
}

export function getOnboardingModeLabel(mode: OnboardingMode | null) {
  return mode ? modeLabels[mode] : modeLabels.guided
}